<template>
  <section class="blog blog--page">
    <div class="main-container">
      <h2 class="blog__header heading heading--md heading--underlined">
        Developers blog
      </h2>
      <div v-if="bigPost" id="blog-latest">
        <big-post :post="bigPost"></big-post>
      </div>
      <div id="blog-list">
        <post v-for="post in posts" :key="post.id" :post="post"> </post>
      </div>
      <div v-if="hasNext" class="text--center">
        <button
          id="loadMoreBlogPostsButton"
          class="blog__load butn"
          @click="loadNext()"
        >
          <div class="blog__load-text">load more</div>
          <i class="blog__load-icon iconmoon-backtotop"></i>
        </button>
      </div>
    </div>
  </section>
</template>
<script>
import Post from "../partials/Blog/Post.vue";
import BigPost from "../partials/Blog/BigPost.vue";
import { mapActions, mapGetters } from "vuex";

export default {
  components: {
    post: Post,
    "big-post": BigPost
  },
  data() {
    return {};
  },
  metaInfo: {
    title: "Blog"
  },
  created() {
    this.fetch();
  },
  computed: {
    ...mapGetters("posts", {
      hasNext: "hasNext",
      posts: "posts",
      bigPost: "bigPost",
      page: "page",
      rowsPerPage: "rowsPerPage"
    })
  },
  methods: {
    ...mapActions("posts", {
      fetch: "fetch",
      fetchNext: "fetchNext",
      incrementPage: "incrementPage"
    }),
    async loadNext() {
      this.incrementPage();
      await this.fetchNext();
    }
  }
};
</script>
